<div class="page-container">
    <div class="page-header">
        <div class="header-content">
            <h1 class="page-title">User Settings</h1>
            <p class="page-subtitle">Manage user roles and permissions</p>
        </div>
    </div>

    <!-- Loading Spinner -->
    <div *ngIf="isLoading" class="loading-overlay">
        <mat-spinner diameter="50" color="primary"></mat-spinner>
        <p class="loading-text">Loading roles...</p>
    </div>

    <div class="split-panel" [class.loading]="isLoading">

        <!-- Left: Role List -->
        <div class="role-list-panel">
            <div class="panel-header">
                <mat-icon>badge</mat-icon>
                <span>Roles</span>
                <span class="roles-count">{{ roleList.length }}</span>
            </div>

            <!-- Add Role Input -->
            <div class="add-role-row">
                <input
                    type="text"
                    class="role-input"
                    [(ngModel)]="newRoleName"
                    placeholder="New role name..."
                    (keyup.enter)="addRole()"
                />
                <button class="btn-add-role" (click)="addRole()" title="Add Role">
                    <mat-icon>add</mat-icon>
                </button>
            </div>

            <div class="role-list" *ngIf="roleList.length > 0; else noRoles">
                <div
                    *ngFor="let role of roleList"
                    class="role-item"
                    [class.active]="selectedRole?.id === role.id"
                    (click)="selectRole(role)"
                >
                    <div class="role-avatar">{{ getRoleInitial(role) }}</div>
                    <span class="role-name">{{ role.name }}</span>
                    <button class="btn-remove" (click)="removeRole(role); $event.stopPropagation()" title="Delete">
                        <mat-icon>close</mat-icon>
                    </button>
                </div>
            </div>

            <ng-template #noRoles>
                <div class="empty-state">
                    <mat-icon class="empty-icon">badge</mat-icon>
                    <p>No roles yet</p>
                </div>
            </ng-template>
        </div>

        <!-- Right: Permission Panel -->
        <div class="permission-panel">
            <ng-container *ngIf="selectedRole; else selectPrompt">
                <div class="panel-header">
                    <mat-icon>security</mat-icon>
                    <span>Permissions — {{ selectedRole.name }}</span>
                </div>

                <div class="permission-body">
                    <div class="permission-table">
                        <!-- Table Header -->
                        <div class="perm-row perm-header">
                            <div class="perm-label">Module</div>
                            <div class="perm-toggle-col">View</div>
                            <div class="perm-toggle-col">Editable</div>
                        </div>

                        <!-- Permission Rows -->
                        <ng-container *ngFor="let perm of selectedRole.permissions">
                            <!-- Parent Row -->
                            <div class="perm-row" [class.has-children]="perm.children?.length">
                                <div class="perm-label">
                                    <mat-icon class="perm-icon">
                                        {{ perm.key === 'dashboard' ? 'dashboard' :
                                           perm.key === 'user_management' ? 'manage_accounts' :
                                           perm.key === 'customer_management' ? 'people' :
                                           perm.key === 'consignee_registration' ? 'how_to_reg' :
                                           perm.key === 'shipping_order' ? 'local_shipping' :
                                           perm.key === 'booking_list' ? 'list_alt' :
                                           perm.key === 'fleet_management' ? 'directions_car' :
                                           perm.key === 'report' ? 'assessment' :
                                           perm.key === 'accounting' ? 'account_balance' :
                                           perm.key === 'settings' ? 'settings' : 'circle' }}
                                    </mat-icon>
                                    {{ perm.label }}
                                </div>
                                <div class="perm-toggle-col">
                                    <label class="toggle">
                                        <input type="checkbox" [(ngModel)]="perm.view" (change)="onViewChange(perm)">
                                        <span class="slider"></span>
                                    </label>
                                </div>
                                <div class="perm-toggle-col">
                                    <label class="toggle">
                                        <input type="checkbox" [(ngModel)]="perm.edit" (change)="onEditChange(perm)">
                                        <span class="slider"></span>
                                    </label>
                                </div>
                            </div>

                            <!-- Children Rows -->
                            <ng-container *ngIf="perm.children?.length">
                                <div *ngFor="let child of perm.children" class="perm-row perm-child">
                                    <div class="perm-label">
                                        <span class="child-indent"></span>
                                        <mat-icon class="perm-icon child-icon">
                                            {{ child.key === 'truck_profile' ? 'local_shipping' :
                                               child.key === 'driver_profile' ? 'person' :
                                               child.key === 'transport_management' ? 'route' : 'subdirectory_arrow_right' }}
                                        </mat-icon>
                                        {{ child.label }}
                                    </div>
                                    <div class="perm-toggle-col">
                                        <label class="toggle">
                                            <input type="checkbox" [(ngModel)]="child.view" (change)="onChildViewChange(perm, child)">
                                            <span class="slider"></span>
                                        </label>
                                    </div>
                                    <div class="perm-toggle-col">
                                        <label class="toggle">
                                            <input type="checkbox" [(ngModel)]="child.edit" (change)="onChildEditChange(perm, child)">
                                            <span class="slider"></span>
                                        </label>
                                    </div>
                                </div>
                            </ng-container>
                        </ng-container>
                    </div>

                    <div class="action-bar">
                        <button class="btn-save" (click)="savePermissions()" [disabled]="isSaving">
                            <mat-icon>{{ isSaving ? 'hourglass_empty' : 'save' }}</mat-icon>
                            <span>{{ isSaving ? 'Saving...' : 'Save Permissions' }}</span>
                        </button>
                    </div>
                </div>
            </ng-container>

            <ng-template #selectPrompt>
                <div class="empty-state tall">
                    <mat-icon class="empty-icon">touch_app</mat-icon>
                    <h3>Select a role</h3>
                    <p>Click on a role to manage its permissions</p>
                </div>
            </ng-template>
        </div>

    </div>
</div>
